import React from 'react';
import { BookOpen, Star } from 'lucide-react';
export function OfferBar() {
  return <div className="fixed top-0 left-0 w-full z-[1000] bg-gradient-to-r from-[#1B3A6B] via-[#2D4F85] to-[#1B3A6B] text-[#FDFAF7] text-center py-3 px-4 text-xs md:text-sm font-medium shadow-lg border-b border-[#335C94]/30 flex justify-center items-center gap-2" data-id="element-225">
      <div className="flex items-center gap-2 animate-pulse-rose" data-id="element-226">
        <BookOpen className="w-4 h-4 text-[#B83A52]" data-id="element-227" />
        <span className="tracking-wide font-bold flex items-center gap-1.5" data-id="element-228">
          <Star className="w-3.5 h-3.5 text-[#FCD34D] fill-[#FCD34D]" data-id="element-229" />
          OFERTA DE LANZAMIENTO
        </span>
      </div>
      <span className="hidden md:inline text-[#EEF2F7]/60 mx-2" data-id="element-230">|</span>
      <span className="hidden md:inline font-semibold text-[#EEF2F7]" data-id="element-231">
        Guía completa por solo $7.77 — Acceso digital inmediato
      </span>
    </div>;
}